import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { H3 } from 'components/common/headers';
import InsetContainer from 'components/common/containers/inset_container';
import StackContainer from 'components/common/containers/stack_container';
import Modal from 'components/lib/modal';
import ModalButton, { ModalButtonDivider } from 'components/modals/modal_button';
import ModalFooter from 'components/modals/modal_footer';
import PortalModalWrapper from 'components/lib/portal_modal_wrapper';
import TrashWithBorderIcon from 'components/lib/icons/trash_with_border_icon';

const DeleteTeamModalWrapper = styled(Modal)`
  background: ${p => p.theme.colors.white};
  border-radius: ${p => p.theme.borderRadius.default};
  min-width: 325px;
  text-align: center;
  .deleteTeamModal-message {
    justify-content: center;
  }
`;

const DeleteTeamModalFooter = styled(ModalFooter)`
  .deleteTeamModal-cancelBtn {
    border-bottom-left-radius: ${p => p.theme.borderRadius.default};
  }
  .deleteTeamModal-confirmBtn {
    border-bottom-right-radius: ${p => p.theme.borderRadius.default};
  }
`;

const DeleteTeamModalTrashIcon = styled(TrashWithBorderIcon)`
  align-self: center;
  fill: none;
  height: 24px;
  width: 24px;
`;

const DeleteTeamModalMessage = styled(H3)`
  font-weight: bold;
`;

const DeleteTeamModalMessageWrapper = styled(StackContainer)`
  padding-bottom: 0px;
`;

const TrashIconWrapper = styled(StackContainer)`
  margin-bottom: ${p => p.theme.spacing.stackLarge};
  margin-right: ${p => p.theme.spacing.stackXLarge};
`;

function DeleteTeamModal({ onCancel, onConfirm }) {
  return (
    <PortalModalWrapper>
      <DeleteTeamModalWrapper data-aid="deleteTeamModal-wrapper">
        <InsetContainer>
          <TrashIconWrapper>
            <DeleteTeamModalTrashIcon data-aid="deleteTeamModal-trashIcon" />
          </TrashIconWrapper>
          <DeleteTeamModalMessageWrapper>
            <DeleteTeamModalMessage className="deleteTeamModal-message">Delete the team?</DeleteTeamModalMessage>
          </DeleteTeamModalMessageWrapper>
        </InsetContainer>
        <DeleteTeamModalFooter>
          <ModalButton className="deleteTeamModal-cancelBtn" onClick={onCancel}>
            Cancel
          </ModalButton>
          <ModalButtonDivider />
          <ModalButton className="deleteTeamModal-confirmBtn" onClick={onConfirm}>
            Delete
          </ModalButton>
        </DeleteTeamModalFooter>
      </DeleteTeamModalWrapper>
    </PortalModalWrapper>
  );
}

DeleteTeamModal.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default DeleteTeamModal;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/modals/delete_team_modal.jsx